import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { categories } from "@/mocks/anime";

export default function Hero() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  function onSearch(e: React.FormEvent) {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/list/all?q=${encodeURIComponent(q)}` : "/list/all");
  }

  return (
    <section className="relative flex min-h-[560px] w-full items-center overflow-hidden md:min-h-[680px]">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20stylized%20anime%20illustration%20of%20a%20playful%20orange%20tiger%20snuggling%20among%20floating%20movie%20posters%20and%20popcorn%2C%20cozy%20night%20watching%20anime%20vibe%2C%20rich%20crimson%20orange%20and%20golden%20amber%20palette%2C%20soft%20glowing%20lights%2C%20cinematic%20wide%20composition%2C%20charming%20flat%20storybook%20style&width=1600&height=900&seq=xh-hero-01&orientation=landscape"
        alt="小虎看番 · 一只老虎在看番的暖色插画背景"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/60 via-primary-900/40 to-primary-950/70"></div>

      <div className="relative z-10 mx-auto w-full max-w-6xl px-4 pb-16 pt-28 text-center md:px-6">
        <span className="mx-auto inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur-sm">
          <i className="ri-flashlight-fill text-accent-300" aria-hidden="true"></i>
          告别剧荒 · 一只老虎帮你挑好番
        </span>

        <h1 className="mx-auto mt-6 max-w-3xl font-display text-4xl leading-tight text-background-50 md:text-6xl md:leading-tight">
          高分番列表 &amp; 冷门佳作，
          <span className="text-accent-300">点开就有片单</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-50/85 md:text-base">
          不知道补什么？小虎看番为你整理高分番列表、冷门佳作与口碑番排行，还有完结番合集和熬夜补番清单。
          无论想刷经典还是挖宝藏，都能找到合口味的片单。
        </p>

        <form
          onSubmit={onSearch}
          className="mx-auto mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row sm:rounded-full sm:bg-background-50 sm:p-2 sm:shadow-none"
        >
          <label htmlFor="hero-search" className="sr-only">
            搜索番剧
          </label>
          <div className="flex flex-1 items-center gap-2 rounded-full bg-background-50 px-4 sm:bg-transparent sm:px-3">
            <i className="ri-search-line text-lg text-foreground-400" aria-hidden="true"></i>
            <input
              id="hero-search"
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索片名、类型或关键词，如：治愈、悬疑"
              className="h-11 w-full bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none sm:h-10"
            />
          </div>
          <button
            type="submit"
            className="h-11 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:h-10"
          >
            开找好番
          </button>
        </form>

        <div className="mx-auto mt-9 flex max-w-3xl flex-wrap items-center justify-center gap-2.5">
          {categories.map((c) => (
            <a
              key={c.id}
              href={c.path}
              onClick={(e) => {
                e.preventDefault();
                navigate(c.path);
              }}
              className="group inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-4 py-2 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-accent-500 hover:text-foreground-900"
            >
              <i className="ri-price-tag-3-line text-accent-200 transition-colors group-hover:text-foreground-900" aria-hidden="true"></i>
              {c.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}